import * as React from 'react';
import { useStyles, noop } from '@sravni/react-utils';
import modules_5f96f03e from '../styles/Switch.module.less.js';

/**
 * @description The Switch component is used to switch between two options and the result of the change is immediate
 *
 * @component
 * @example
 * ```jsx
 * <Switch>content</Switch>
 * ```
 */
const Switch = React.forwardRef((props, ref) => {
    const { name, value, checked, disabled, readOnly, className, children, onChange = noop, ...restProps } = props;
    const cx = useStyles(modules_5f96f03e);
    const classNames = cx(className, 'container', {
        checked,
        disabled,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'read-only': readOnly,
    });
    const controlClassNames = cx('control', {
        checked,
        disabled,
    });
    const handlerClassNames = cx('handler', {
        checked,
        disabled,
    });
    // const handleClick = (event)
    return (React.createElement("label", { "data-qa": "Switch", className: classNames },
        React.createElement("input", { ref: ref, className: cx('input'), type: "checkbox", name: name, value: value, checked: checked, disabled: disabled, onChange: onChange, ...restProps }),
        React.createElement("div", { className: controlClassNames },
            React.createElement("div", { className: handlerClassNames })),
        children ? React.createElement("span", { className: cx('label') }, children) : null));
});
Switch.defaultProps = {
    checked: false,
};
Switch.displayName = 'Switch';

export { Switch };
//# sourceMappingURL=Switch.js.map
